export const CrossIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      y='21.213'
      width='30'
      height='3.333'
      rx='1.667'
      transform='rotate(-45 0 21.213)'
      fill='currentColor'
    />
    <rect
      x='2.357'
      width='30'
      height='3.333'
      rx='1.667'
      transform='rotate(45 2.357 0)'
      fill='currentColor'
    />
  </svg>
);
